<template>
    <va-edit-layout>
        <FbaInventoryGroup-form
            :id="id"
            :title="title"
            :item="item"
        ></FbaInventoryGroup-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
